import globalsTheme from './globals/custom-local-theme.module.less';

const localTheme = {
  globals: globalsTheme,
};

export { localTheme };
